import autoBind from 'react-autobind'
import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import axios from 'axios';



class ContactForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name:"",
      email:"",
      company:"",
      nacin:"",
      location:"press",
      startTransition: false,
      nextScreen: false,
      inputOk1: true,
      inputOk2: true,
      inputOk3: true,
    };
    autoBind(this);
  }

  handleClick2(){
    this.setState({startTransition: !this.state.startTransition});
    if(this.props.onClick()){
      this.props.onClick();
    }
  }
  
  handleRegister(){
      if(this.state.name === ""){
        this.setState({inputOk1:false});
      } else {
        this.setState({inputOk1:true});
      }

      this.setState({inputOk3:true});

      if(this.state.email === ""){
        this.setState({inputOk2:false});
      } else {
        this.setState({inputOk2:true});
      }
      if(this.state.name !== "" && this.state.email !== ""){
        this.props.onClick();
        this.setState({nacin: "Odpisali vam bomo v najkrajšem možnem času. V kolikor našega odgovora ne prejmete v roku treh delovnih dni nam to prosim sporočite na elektronski naslov", startTransition: true});
        setTimeout(() => {
          axios.post('https://email.mtoffice.net/mail1', this.state).then(response => {
              console.log(response);
            })
            .catch(error => {
              console.log(error);
            });
          setTimeout(() => this.setState({ nextScreen: true}), 400);
        }, 200);
        setTimeout(() => this.setState({ nextScreen: true}), 400);
      }
  }

  handleClose(){
    this.props.onClick();
    this.setState({ startTransition: false});
    this.setState({ nextScreen: false});
  }

  render() {
    const inputOkState1 = this.state.inputOk1 ? styles.boxInputOk : styles.boxInputError;
    const inputOkState2 = this.state.inputOk2 ? styles.boxInputOk : styles.boxInputError;
    const inputOkState3 = this.state.inputOk3 ? styles.boxInputOk : styles.boxInputError;
    const firstScreenState = this.state.startTransition ? styles.wrapperOut : styles.wrapperIn;

    
    return (
    <div>
      {!this.state.nextScreen ? 
        <div className={css(firstScreenState)}>
          <div className={css(styles.flex)}>
            <input
              type="name"
              className={css(styles.boxInput, styles.boxInput1, inputOkState1)}
              placeholder="FULL NAME"
              onChange={e => this.setState({ name: e.nativeEvent.target.value })}
            />
            <input
              type="email"
              className={css(styles.boxInput, inputOkState2)}
              placeholder="EMAIL"
              onChange={e => this.setState({ email: e.nativeEvent.target.value })}
            />
            <input
              type="text"
              className={css(styles.boxInput, inputOkState3)}
              placeholder="COMPANY"
              onChange={e => this.setState({ company: e.nativeEvent.target.value })}
            />
         
            <div className={css(styles.buttonWrapper)}>
              <div onClick={this.handleRegister} className={css(styles.button)}>SEND</div>
            </div>
            {!this.state.inputOk1 || !this.state.inputOk2 || !this.state.inputOk3 ?
              <div className={css(styles.redText)}>Please fill-in the red inputs</div>
            :
              null
            }
          </div>
        </div>
        :
        <div style={{"opacity":0}} className={css(styles.nextScreenSecond)}>
            <div className={css(styles.textCenter)}>{this.state.name}, THANK YOU FOR CONTACTING US.</div>
            <div className={css(styles.textCenterSmall)}>
              WE WILL TRY OUR BEST, SO THAT OUR RESPONSE IS AS FAST AS APEX.
            </div>
            <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
            <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
            <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
          </svg>

          <div onClick={this.handleClose} className={css(styles.button1)} to="/contact">BACK
          </div>

        </div>
        }
      </div>
    );
  }
}


const styles = StyleSheet.create({
  wrapperIn: {
    position:"relative",
    opacity:1,
    width:"100%",
    transition:"0.5s",
    margin:"0 auto",
  },
  wrapperOut: {
    position:"relative",
    opacity:0,
    width:"100%",
    margin:"0 auto",
    transition:"0.5s",
  },
  flex:{
    maxWidth:450,
    margin:"0 auto",
    '@media (max-width: 660px)': {
      marginTop:40,
      maxWidth:400,
    },
  },
  link:{
    textDecoration:"none",
    color:"black",
    padding: 4,
    fontSize:17,
    fontWeight:300,
    webkitTransition:"0.3s  cubic-bezier(0,0,0,5)",
    transition:"0.3s  cubic-bezier(0,0,0,5)",
    display:"block",
    ":hover":{
      color:"#333333",
    }
  },
  boxInput1: {
    marginTop:0,
  },
  boxInput: {
    transition:"0.4s",
    width:"100%",
    '::-webkit-input-placeholder': {
        color: '#fff',
        letterSpacing:0.4,
        fontWeight:600,
        fontSize:16,
    },
    '::-moz-placeholder': {
      color: '#fff',
      letterSpacing:0.4,
      fontWeight:600,
      fontSize:16,
    },
    ':-ms-input-placeholder': {
      color: '#fff',
      letterSpacing:0.4,
      fontWeight:600,
      fontSize:16,
    },
    marginTop:10,
    outline:"none",
    textAlign:"left",
    fontSize:19,
    paddingTop:7,
    paddingBottom:7,
    paddingLeft:20,
    color: '#fff',
    background: "#000",
    border:"2px #FBBC01 solid",
    minHeight:40,
    borderRadius:20,
    maxWidth:550,
    marginBottom:20,
  
    '@media (max-width: 760px)': {
      fontSize:17,
      marginBottom:10,
    },
  },
  boxInputOk:{
    border:"2px #FBBC01 solid",
  },
  boxInputError:{
    border:"2px #cc0000 solid",
  },
  text: {
    color:"#fff",
    fontSize:25,
    fontWeight:400,
    margin:"30px auto",
    marginTop:20,
    letterSpacing:0.8,
    '@media (max-width: 860px)': {
       fontSize:22,
    },
    '@media (max-width: 760px)': {
      fontSize:18,
    },
  },
  buttonWrapper: {
    display:"flex",
    marginTop:30,
    justifyContent:"space-between",
    '@media (max-width: 660px)': {
      justifyContent:"flex-start",
    },
  },
  button: {
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
    fontWeight:600,
    letterSpacing:0.4,
    cursor:"pointer",
    fontSize:18,
    lineHeight:1.7,
    height:40,
    width:190,
    margin:"0 auto",
    color:"#000",
    borderRadius:23,
    background:"#FBBC01",
   '@media (max-width: 860px)': {
       width:160,
    },
    '@media (max-width: 760px)': {
      width:140,
    },
  },

  nextScreenSecond: {
    transition:"0.6s",
    width:"100%",
    margin:"0 auto",
    opacity:1,
  },

  textCenter: {
    textAlign:"center",
    margin:"20px auto",
    marginTop:60,
    fontWeight:500,
    color:"#fff",
    fontSize:25,
  },
  textCenterSmall: {
    textAlign:"center",
    margin:"20px auto",
    marginBottom:25,
    color:"#FBBC01",
    fontSize:20,
  },

  button1:{
    margin:"0 auto",
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
    fontWeight:500,
    letterSpacing:0.4,
    cursor:"pointer",
    fontSize:16,
    lineHeight:1.7,
    height:35,
    width:170,
    color:"#000",
    borderRadius:23,
    background:"#FBBC01",
    // '@media (max-width: 1040px)': {
    //   fontSize:14,
    // },
  },
  progressBar1:{
    width:90,
    height:2,
    transition:"0.2s ease-out",
    background:"#000",
  },
  redText:{
    color:"#cc0000",
    fontSize:14,
    marginTop:3,
  },

});

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/PressContactForm.js